import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

import "bootstrap/dist/css/bootstrap.css";
import "./index.css";

import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <div className="body">
      <App />
      <div className="footer-text">
        <footer>
          <a
            className="footer-text"
            href="https://github.com/laurenc508/react-weather-app"
            target="_blank"
            rel="no opener noreferrer"
          >
            Open-sourced on Github
          </a>{" "}
          and coded by Lauren Cooper
        </footer>
      </div>
    </div>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
